import {IDataHeader, IDataHeaderGroup} from '..';

import {DataHeader} from './data-header';

export class DataHeaderGroup {
    public selector: string;
    public label: string;
    public colspan: number;
    public shifted: boolean;
    public sortable: boolean;
    public childColumns: DataHeader[];
    public sortIndex: number;

    constructor(data: IDataHeaderGroup) {
        this.selector = data.selector;
        this.label = data.label;
        this.shifted = data.shifted;
        this.childColumns = data.childColumns.map((column: IDataHeader) => new DataHeader(column));
        this.colspan = this.childColumns.length;
        this.sortIndex = !data.sortIndex ? 0 : data.sortIndex;
        this.sortable = false;
    }
}
